import { FC } from 'react'
import { Badge, BadgeProps, IconButton, Tooltip, styled } from '@mui/material'
import { InsertDriveFileOutlined as ViewFileIcon } from '@mui/icons-material'
import { exceptionMessageHandler } from '$utils'
import { useFileViewer } from '$hooks'

type FileIconButtonProps = {
  fetchFile: () => Promise<{
    fileBlob: Blob
    contentType: string
  }>
  fileName: string
  badgeContent?: number | string
  disabled?: boolean
  showTooltip?: boolean
  tooltipText?: string
  errorMessage?: string
}

const FileBadge = styled(Badge)<BadgeProps>(() => ({
  '& .MuiBadge-badge': {
    height: '15px',
    minWidth: '15px',
    right: 8,
    top: 25,
    fontSize: '10px',
    padding: '0 4px',
  },
}))

const FileIconButton: FC<FileIconButtonProps> = ({
  fetchFile,
  fileName,
  badgeContent,
  disabled = false,
  showTooltip = false,
  tooltipText = 'View PDF file',
  errorMessage = 'Failed to download file',
}) => {
  const { setIsFileVisible, setData } = useFileViewer()

  const handleViewFile = async () => {
    try {
      setIsFileVisible(true)
      const { fileBlob, contentType } = await fetchFile()
      setData({ fileName, fileBlob, contentType })
    } catch (error) {
      setIsFileVisible(false)
      exceptionMessageHandler(error, errorMessage)
    }
  }

  const iconButton = (
    <IconButton
      sx={{ padding: '4px' }}
      disabled={disabled}
      onClick={handleViewFile}
    >
      <ViewFileIcon />
    </IconButton>
  )

  return (
    <FileBadge badgeContent={badgeContent} color="primary">
      {showTooltip ? (
        <Tooltip title={tooltipText}>{iconButton}</Tooltip>
      ) : (
        iconButton
      )}
    </FileBadge>
  )
}

export default FileIconButton
